import { SVGProps } from 'react';
const IcUpload = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='none' {...props}>
    <path
      d='M21.501 34V13.625L15.001 20.125L11.501 16.5L24.001 4L36.501 16.5L33.001 20.125L26.501 13.625V34H21.501ZM9.00098 44C7.62598 44 6.44889 43.5104 5.46973 42.5312C4.49056 41.5521 4.00098 40.375 4.00098 39V31.5H9.00098V39H39.001V31.5H44.001V39C44.001 40.375 43.5114 41.5521 42.5322 42.5312C41.5531 43.5104 40.376 44 39.001 44H9.00098Z'
      fill='#64748B'
    />
  </svg>
);
export default IcUpload;
